import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { ErrorWrapper } from '@trade-platform/ui-shared';
import { OrderFinishMapSignaturesActions, OrderFinishMapSignaturesActionTypes } from './actions';

export type OrderFinishMapSignaturesState = RemoteData<null, ErrorWrapper>;
const initialState = notAsked<null, ErrorWrapper>();

export const orderFinishMapSignaturesReducer = (
    state: OrderFinishMapSignaturesState = initialState,
    action: OrderFinishMapSignaturesActions
): OrderFinishMapSignaturesState => {
    switch (action.type) {
        case OrderFinishMapSignaturesActionTypes.ORDER_FINISH_MAP_SIGNATURES:
            return inProgress();
        case OrderFinishMapSignaturesActionTypes.ORDER_FINISH_MAP_SIGNATURES_SUCCESS:
            return success(null);
        case OrderFinishMapSignaturesActionTypes.ORDER_FINISH_MAP_SIGNATURES_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
};
